import { number, object, string } from "yup";
import { dateMax } from "./utils";

export const MANDAT_PRELEVEMENT_IV = {
  id_tenant: "",
  id_profile_bailleur: "",
  iban: "",
  bic: "",
  rum: "",
  date_mandat: "",
  instrument: "core",
};

// schema yup

export const mandatPrelevementSchema = object({
  id_tenant: number().required(" "),
  id_profile_bailleur: number().required(" "),
  iban: string().max(34).required(" "),
  bic: string().max(11).required(" "),
  rum: string().max(255).required(" "),
  date_mandat: dateMax().required(" "),
  instrument: string().max(4).required(" "),
});

export const MANDAT_PRELEVEMENT_FICHIER_IV = {
  date_prelevement: "",
};

export const mandatPrelevementFichierSchema = object({
  date_prelevement: dateMax().required(" "),
});
